/**
 * Tipos de acciones para el módulo de bandejas (trays)
 * Bandejas = pools compartidos de contactos por id_customer.
 * El CRUD vive en la vista; la operación de cola (queue/take) vive en el chat.
 */

// Selección de bandeja activa en el chat
export const SET_ACTIVE_TRAY = 'SET_ACTIVE_TRAY';

// Cola de una bandeja (asignaciones available)
export const GET_TRAY_QUEUE = 'GET_TRAY_QUEUE';
export const GET_TRAY_QUEUE_SUCCESS = 'GET_TRAY_QUEUE_SUCCESS';
export const GET_TRAY_QUEUE_ERROR = 'GET_TRAY_QUEUE_ERROR';

export const TRAY_QUEUE_SYNC_CONTACT = 'TRAY_QUEUE_SYNC_CONTACT';

// Transferir un contacto a una bandeja (agente → cola)
export const TRANSFER_CONTACT_TO_TRAY = 'TRANSFER_CONTACT_TO_TRAY';
export const TRANSFER_CONTACT_TO_TRAY_SUCCESS = 'TRANSFER_CONTACT_TO_TRAY_SUCCESS';
export const TRANSFER_CONTACT_TO_TRAY_ERROR = 'TRANSFER_CONTACT_TO_TRAY_ERROR';

// Obtener bandejas
export const GET_TRAYS = 'GET_TRAYS';
export const GET_TRAYS_SUCCESS = 'GET_TRAYS_SUCCESS';
export const GET_TRAYS_ERROR = 'GET_TRAYS_ERROR';

// Crear bandeja
export const CREATE_TRAY = 'CREATE_TRAY';
export const CREATE_TRAY_SUCCESS = 'CREATE_TRAY_SUCCESS';
export const CREATE_TRAY_ERROR = 'CREATE_TRAY_ERROR';

// Actualizar bandeja
export const UPDATE_TRAY = 'UPDATE_TRAY';
export const UPDATE_TRAY_SUCCESS = 'UPDATE_TRAY_SUCCESS';
export const UPDATE_TRAY_ERROR = 'UPDATE_TRAY_ERROR';

// Eliminar bandeja
export const DELETE_TRAY = 'DELETE_TRAY';
export const DELETE_TRAY_SUCCESS = 'DELETE_TRAY_SUCCESS';
export const DELETE_TRAY_ERROR = 'DELETE_TRAY_ERROR';
